export function isControlHotkey(event: KeyboardEvent, keyCode: number, key: string) {
  return (event.metaKey || event.ctrlKey) && (event.keyCode === keyCode || event.key === key)
}
